import { Card } from "@mui/material";
import React from "react";

export default function CardCarousel({
  detailArray,
  isActive,
  prevIndex,
}) {
  const activeCarousel = detailArray[isActive];
  const prevCarousel =
    prevIndex < 0
      ? detailArray[(isActive + 4) % detailArray.length]
      : detailArray[prevIndex];

  return (
    <div className="carousel-container">
      {/* <Card
        className="card-carousel card-before d-flex flex-column justify-content-center align-items-center p-2 gap-3"
        sx={{ backgroundColor: prevCarousel.bgColor }}
      >
        <Typography variant="h3" style={{ fontWeight: "400" }}>
          <span
            style={{
              fontSize: "48px",
              color: prevCarousel.primaryColor,
              fontWeight: "500",
            }}
          >
            {prevCarousel.title.charAt(0)}
          </span>
          {prevCarousel.title.slice(1)}
        </Typography>
        <Icon sx={{ color: prevCarousel.primaryColor, fontSize: "174px" }}>
          {prevCarousel.icon}
        </Icon>
        <p className="text-center" style={{ fontSize: "18px" }}>
          {prevCarousel.desc}
        </p>
      </Card> */}
      <Card
        className="card-carousel card-before d-flex flex-column justify-content-between align-items-start gap-50"
        sx={{ backgroundColor: prevCarousel.bgColor }}
      >
        <div className="d-flex flex-column justify-content-between p-2 gap-1">
          <h2 className="text-white" style={{ fontWeight: 500 }}>
            {prevCarousel.title}
          </h2>
          <p className="text-white" style={{ fontSize: "18px" }}>
            {prevCarousel.desc}
          </p>
        </div>
        <img src={prevCarousel.img} alt="Mostrans Core Values" />
      </Card>
      <Card
        key={activeCarousel.id}
        className="card-carousel card-front d-flex flex-column justify-content-between align-items-start gap-50"
        sx={{ backgroundColor: activeCarousel.bgColor }}
      >
        <div className="d-flex flex-column justify-content-between p-2 gap-1">
          <h2 className="text-white" style={{ fontWeight: 500 }}>
            {activeCarousel.title}
          </h2>
          <p className="text-white" style={{ fontSize: "18px" }}>
            {activeCarousel.desc}
          </p>
        </div>
        <img src={activeCarousel.img} alt="Mostrans Core Values" />
      </Card>
      <Card
        className="card-carousel card-back-1"
        sx={{
          backgroundColor:
            detailArray[(isActive + 1) % detailArray.length].bgColor,
        }}
      />
      <Card
        className="card-carousel card-back-2"
        sx={{
          backgroundColor:
            detailArray[(isActive + 2) % detailArray.length].bgColor,
        }}
      />
      <Card
        className="card-carousel card-back-3"
        sx={{
          backgroundColor:
            detailArray[(isActive + 3) % detailArray.length].bgColor,
        }}
      />
      <Card
        className="card-carousel card-back-4"
        sx={{
          backgroundColor:
            detailArray[(isActive + 4) % detailArray.length].bgColor,
        }}
      />
    </div>
  );
}
